import React, { Dispatch, SetStateAction, useState } from 'react';
import Icon from '@ant-design/icons';
import { message } from 'antd';
import TransparentButton from '../../../../../../components/ui/TransparentButton/TransparentButton';
import { ReactComponent as Back } from '../../../../../../assets/images/personalAccount/back.svg';
import MyBtn from '../../../../../../components/ui/MyBtn/MyBtn';
import s from './BankOrMobileTopUpConfirmation.module.css';
import { useAppDispatch } from '../../../../../../store/store';
import { createCentiwiseTransactionThunk } from '../../../../../../store/reducers/ActionCreators';
import { useAppSelector } from '../../../../../../hooks/redux';
import CustomModal from '../../../../../../components/ui/CustomModal/CustomModal';

type PropsType = {
  setCurrent: Dispatch<SetStateAction<any>>;
  transferData: any;
};

const BankOrMobileTopUpConfirmation = ({ setCurrent, transferData }: PropsType) => {
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [redirectModel, setRedirectModel] = useState(false);
  const [reDirectUrl, setRedirectUrl] = useState('');
  const dispatch = useAppDispatch();
  const token = useAppSelector(state => state.userReducer.user.userToken);

  const handleTransaction = async () => {
    setIsButtonDisabled(true);
    try {
      const res = await dispatch(createCentiwiseTransactionThunk(token, transferData));
      const { redirect_url } = res.data.data;
      if (res.data.status === 'success') {
        setRedirectUrl(redirect_url);
        setRedirectModel(true);
      } else if (res.data.status === 'processing') {
      } else {
        message.error(res.data.message || 'Transaction failed.');
      }
    } catch (error: any) {
      const errorMessage = error?.response?.data?.message || 'An unexpected error occurred.';
      message.error(errorMessage);
    } finally {
      setIsButtonDisabled(false);
    }
  };
  const onTransactionConfirm = () => {
    if (reDirectUrl) {
        window.open(reDirectUrl, "_blank");
    }
    setCurrent('form');
};

  return (
    <React.Fragment>
      <CustomModal setIsModalOpen={setRedirectModel} isModalOpen={redirectModel}>
        <div>
          <div className={s.popup_title}>Success!</div>
          <span className={s.popup_subtitle}>
            {' '}
            Your request has been Approved, with the confirm buttomn you will redirect to payment screen.
          </span>
          <div className={s.popup_button_wrapper}>
            <div className={s.btn_block}>
              <MyBtn title={'Confirm'} onClick={onTransactionConfirm} />
            </div>
            <div className={s.btn_block}>
              <MyBtn title={'Cancel'} buttonType="error" onClick={() => setRedirectModel(false)} />
            </div>
          </div>
        </div>
      </CustomModal>
      <div className={s.confirmation_wrapper}>
        <h2 className={s.title}>Review Your Details</h2>
        <div className={s.details_block}>
          <div className={s.detail}>
            <span className={s.label}>Account Number:</span>
            <span className={s.value}>{transferData.account_number}</span>
          </div>
          <div className={s.detail}>
            <span className={s.label}>Amount:</span>
            <span className={s.value}>{transferData.amount}</span>
          </div>
          <div className={s.detail}>
            <span className={s.label}>Provider:</span>
            <span className={s.value}>{transferData.provider ? transferData.provider : '--'}</span>
          </div>
        </div>
        <div className={s.btn_block}>
          <div className={s.button_back_wrapper}>
            <TransparentButton
              title={'Back'}
              large
              style={{ width: '100%' }}
              onClick={() => setCurrent('form')}
              icon={<Icon component={() => <Back />} rev={undefined} />}
            />
          </div>
          <div className={s.button_apply_wrapper}>
            <MyBtn title={'Apply'} type={'button'} onClick={handleTransaction} localDisable={isButtonDisabled} />
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default BankOrMobileTopUpConfirmation;
